import { Injectable } from '@angular/core';

import {
	CreateCommentResponse,
	DeleteCommentResponse,
	GetCommentResponse,
	UpdateCommentResponse,
} from '@reach/interfaces/comments/comments.responses';
import { NoteSlateItemInterface } from '@reach/interfaces/notes/note.interface';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class CommentsApiService extends BaseApiService {
	protected commonPath = ['nodes'];

	public async getComments(nodeId: ReachNodeId): Promise<GetCommentResponse> {
		return await this.http.get<GetCommentResponse>(this.url(nodeId, 'comments'));
	}

	public async createComment(
		nodeId: ReachNodeId,
		content: NoteSlateItemInterface[]
	): Promise<CreateCommentResponse> {
		const body = { comment: content || [] };
		return await this.http.post<CreateCommentResponse>(this.url(nodeId, 'comments'), body);
	}

	public async editComment(
		nodeId: ReachNodeId,
		commentId: string,
		content: NoteSlateItemInterface[]
	): Promise<UpdateCommentResponse> {
		const body = { comment: content || [] };
		return await this.http.patch<UpdateCommentResponse>(
			this.url(nodeId, 'comments', commentId),
			body
		);
	}

	public async removeComment(
		nodeId: ReachNodeId,
		commentId: string
	): Promise<DeleteCommentResponse> {
		return await this.http.delete<DeleteCommentResponse>(
			this.url(nodeId, 'comments', commentId)
		);
	}
}
